<template lang="pug">

	b-modal(v-model="showModal" :hide-footer="true" :hide-header="false" title="Добавление доклада" centered id="lectureModalAdd")

		Alerts(ref="Alerts")

		b-form(@submit.prevent='onSubmit')
			component(:is="field.widget" v-model="form[field.name]" v-for="field in htmlModelLecture" :key="field.name" :_field="field" :_checkState="checkState" :_invalidFeedback="invalidFeedback")

			div.g-between-center
				b-button.w-100(type='submit' variant='primary') Отправить

</template>
<script>
	import {mapActions, mapState} from 'vuex';

	import Alerts from '../Alerts';

	import clearFormMixin from '@/MIXINS/clearForm';
	import formBackValidationMixin from '@/MIXINS/formBackValidation';
	import collectFormData from '@/MIXINS/collectFormData';
	import formCallbacks from '@/MIXINS/formCallbacks';

	import modelSession from '@/store/models/modelSession';
	import htmlModelLecture from '@/store/forms/formLecture';

	export default {
		name: 'lectureModal',
		props: ['_userID', 'eventID'],
		data: () => ({
			showModal: false,
			form: {...modelSession},
			htmlModelLecture: [...htmlModelLecture],
			msg: {
				ok: 'Доклад успешно добавлен!',
			},
		}),
		mixins: [
			clearFormMixin,
			formBackValidationMixin,
			collectFormData,
			formCallbacks,
		],
		beforeMount() {
			const cat = this.htmlModelLecture.find(item => item.name === 'category_id');

			this.$store.dispatch('getEventCategoryTypes', {id: this.myParticipant.data.event.id })
				.then( response => {
					if ( response.ok ) {
						cat.options = [
							{ id:null, title:'Выберите секцию' },
							...this.categoryTypes.reduce((acc, {title, session_categories}) => [ ...acc, { label:title, options:session_categories }], [])
						];
					}
				})
		},
		components: { Alerts },
		computed: {
			...mapState(['myParticipant', 'sessions', 'event']),
			...mapState({ categoryTypes:state=>state.event.categoryTypes.data }),

			error() { return this.sessions.post.error; },
			extraData() { return {'event':this.eventID, 'speaker_id':this._userID}; },
		},
		methods: {
			...mapActions(['postSession']),
			...mapActions('myParticipant/nested/lectures', ['getPpntLectures']),
			...mapActions('event/nested/categoryTypes', ['getEventCategoryTypes']),
			checkValid(value) {

			},
			getData() {
				return Object.keys(this.extraData).reduce((acc, key) => (acc.append(key, this.extraData[key]) || acc), this.collectFormData(this.form));
			},
			trimAll(str){ return (str.trim()).replace(/\s+/g, ' ') },
			preSubmit(form){
				Object.keys(form).map( objectKey => {
					if ( typeof form[objectKey] === "string") form[objectKey] = this.trimAll(form[objectKey]);
				});
			},
			onSubmit() {
				this.preSubmit(this.form);

				this.$store.dispatch('postSession', this.getData())
					.then( data => this.sessions.post.error ? this.errHandler(data) : this.okHandler(data))
					.catch( error => this.errHandler(error) );
			},
			okHandlerBefore() {
				this.clearForm('form');
			},
			okHandlerAfter() {
				setTimeout(() => this.$bvModal.hide('lectureModalAdd'), 1000);
				this.$store.dispatch('getPpntLectures', {id: this.myParticipant.data.id});
			},
		},
	};
</script>
<style>
	.custom-file-input ~ .custom-file-label::after {
		content: 'Загрузить' !important;
	}
</style>
